import React from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { Route, useHistory } from "react-router-dom";
import routing from "../../../routing";

import Opus from "./Opus";
import Rhythm from "./Rhythm";
import Pitch from "./Pitch";
import messages from "./messages";
import {
    NavElement,
    Nav,
    StyledMeta,
    Page,
} from "./styles";
import { IProps } from "./interfaces";

const Meta = ({ plan, publicView, type }: IProps) => {
    const history = useHistory();
    return (
        <StyledMeta>
            <Nav>
                <div>
                    <NavElement
                        replace
                        rel="nofollow"
                        to={`/${type}/${plan._id}/${routing.meta}/${routing.metaOpus}`}
                        className={cn(
                            history.location.pathname.slice(-routing.meta.length) === routing.meta && "Active"
                        )}
                        activeClassName={"Active"}
                    >
                        <FormattedMessage {...messages.opus} />
                    </NavElement>
                    <NavElement
                        replace
                        rel="nofollow"
                        to={`/${type}/${plan._id}/${routing.meta}/${routing.metaRhythm}`}
                        activeClassName={"Active"}
                    >
                        <FormattedMessage {...messages.rhythm} />
                    </NavElement>
                    <NavElement
                        replace
                        rel="nofollow"
                        to={`/${type}/${plan._id}/${routing.meta}/${routing.metaPitch}`}
                        activeClassName={"Active"}
                    >
                        <FormattedMessage {...messages.pitch} />
                    </NavElement>
                </div>
            </Nav>
            <Page>
                <Route
                    exact
                    path={`/${type}/:id/${routing.meta}`}
                    render={() => <Opus publicView={publicView} plan={plan} />}
                />
                <Route
                    path={`/${type}/:id/${routing.meta}/${routing.metaOpus}`}
                    render={() => <Opus publicView={publicView} plan={plan} />}
                />
                <Route
                    path={`/${type}/:id/${routing.meta}/${routing.metaRhythm}`}
                    render={() => <Rhythm publicView={publicView} plan={plan} />}
                />
                <Route
                    path={`/${type}/:id/${routing.meta}/${routing.metaPitch}`}
                    render={() => <Pitch publicView={publicView} plan={plan} />}
                />
            </Page>
        </StyledMeta>
    );
}

export default Meta;
